import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export default function AdminTransactions() {
  const [rows, setRows] = useState([]);
  useEffect(() => {
    api.get("/admin/transactions").then(({ data }) => setRows(data));
  }, []);
  return (
    <div data-testid="admin-transactions">
      <h1 className="font-display text-4xl text-ink mb-10">Transactions</h1>
      <div className="bg-bg-surface border border-edge overflow-x-auto">
        <table className="w-full text-left text-sm">
          <thead className="border-b border-edge text-eyebrow text-ink-muted">
            <tr>
              <th className="px-4 py-3">Date</th>
              <th className="px-4 py-3">Service</th>
              <th className="px-4 py-3">Customer</th>
              <th className="px-4 py-3">Status</th>
              <th className="px-4 py-3">Payment</th>
              <th className="px-4 py-3 text-right">Amount</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((r) => (
              <tr key={r.session_id} className="border-b border-edge last:border-0">
                <td className="px-4 py-3 text-ink-muted">{r.created_at?.slice(0, 10)}</td>
                <td className="px-4 py-3 text-ink">{r.service_slug}</td>
                <td className="px-4 py-3 text-ink">{r.customer_email}</td>
                <td className="px-4 py-3 text-ink-muted">{r.status}</td>
                <td className="px-4 py-3">
                  <span
                    className={
                      r.payment_status === "paid"
                        ? "text-brand"
                        : r.payment_status === "expired" || r.payment_status === "failed"
                        ? "text-bad"
                        : "text-ink-muted"
                    }
                  >
                    {r.payment_status}
                  </span>
                </td>
                <td className="px-4 py-3 text-right text-ink">
                  £{r.amount?.toFixed(0)}
                </td>
              </tr>
            ))}
            {rows.length === 0 && (
              <tr>
                <td colSpan="6" className="px-4 py-10 text-center text-ink-muted">
                  No transactions yet.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
